var ScalarFresnelModel = /** @class */ (function () {
    function ScalarFresnelModel(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.center, center = _c === void 0 ? 0 : _c, _d = _b.edge, edge = _d === void 0 ? 1 : _d, _e = _b.centerBias, centerBias = _e === void 0 ? 1 : _e, _f = _b.edgeBias, edgeBias = _f === void 0 ? 0 : _f, _g = _b.power, power = _g === void 0 ? 1 : _g;
        this.edge = edge;
        this.center = center;
        this.centerBias = centerBias;
        this.edgeBias = edgeBias;
        this.power = power;
    }
    ScalarFresnelModel.toEngine = function (scalarFresnel) {
        return [scalarFresnel.center / 100, scalarFresnel.edge / 100,
            scalarFresnel.centerBias / 100, scalarFresnel.edgeBias / 100, scalarFresnel.power];
    };
    return ScalarFresnelModel;
}());
export { ScalarFresnelModel };
